import styled from 'styled-components';

export const Page = styled.main<{ backgroundColor?: string; color?: string }>`
	width: 100%;
	overflow-y: auto;
	background-color: ${({ backgroundColor }) => backgroundColor};
`;
